/**
 * @generated SignedSource<<f07e63a86268f3434caf10e295e2ec52>>
 * @relayHash e473a807b86979029db9afebf54a7e4e
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e473a807b86979029db9afebf54a7e4e

import { ConcreteRequest } from 'relay-runtime';
export type Ch_createOrUpdatePatientBodyMeasurementInput = {
  date: any;
  height?: number | null;
  patientId: string;
  weight: number;
};
export type chCreateOrUpdatePatientBodyMeasurementMutation$variables = {
  connections: ReadonlyArray<string>;
  input: Ch_createOrUpdatePatientBodyMeasurementInput;
};
export type chCreateOrUpdatePatientBodyMeasurementMutation$data = {
  readonly createOrUpdatePatientBodyMeasurement: {
    readonly bodyMeasurement: {
      readonly bodyMassIndex: number | null;
      readonly date: any;
      readonly height: number | null;
      readonly id: string;
      readonly weight: number;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly patientId?: string;
    }> | null;
  };
};
export type chCreateOrUpdatePatientBodyMeasurementMutation = {
  response: chCreateOrUpdatePatientBodyMeasurementMutation$data;
  variables: chCreateOrUpdatePatientBodyMeasurementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = [
  (v3/*:: as any*/)
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*:: as any*/),
  "type": "Error",
  "abstractKey": "__isError"
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v4/*:: as any*/),
  "type": "InvalidWeight",
  "abstractKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": (v4/*:: as any*/),
  "type": "InvalidHeight",
  "abstractKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    (v3/*:: as any*/)
  ],
  "type": "PatientNotFound",
  "abstractKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "BodyMeasurement",
  "kind": "LinkedField",
  "name": "bodyMeasurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "height",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bodyMassIndex",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chCreateOrUpdatePatientBodyMeasurementMutation",
    "selections": [
      {
        "alias": "createOrUpdatePatientBodyMeasurement",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_createOrUpdatePatientBodyMeasurementPayload",
        "kind": "LinkedField",
        "name": "ch_createOrUpdatePatientBodyMeasurement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          },
          (v9/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chCreateOrUpdatePatientBodyMeasurementMutation",
    "selections": [
      {
        "alias": "createOrUpdatePatientBodyMeasurement",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_createOrUpdatePatientBodyMeasurementPayload",
        "kind": "LinkedField",
        "name": "ch_createOrUpdatePatientBodyMeasurement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          },
          (v9/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "bodyMeasurement",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "BodyMeasurementsEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "e473a807b86979029db9afebf54a7e4e",
    "metadata": {},
    "name": "chCreateOrUpdatePatientBodyMeasurementMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "464a22f6c50f5cd19d1737b026124b73";

export default node;
